import React, { useEffect, useRef } from 'react';

// A photo at full size over a darkened page. Closes on Escape, on the
// surround, or on the button; the strip puts focus back where it was.
const Lightbox = ({ src, alt, onClose }) => {
  const closeRef = useRef(null);

  useEffect(() => {
    closeRef.current?.focus();
  }, []);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  // The page behind should not scroll while this is up.
  useEffect(() => {
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, []);

  return (
    <div
      className="helen-lightbox"
      data-testid="helen-lightbox"
      role="dialog"
      aria-modal="true"
      aria-label={alt}
      onClick={onClose}
    >
      <button ref={closeRef} type="button" className="helen-lightbox-close" onClick={onClose}>
        Close
      </button>

      <figure className="helen-lightbox-frame" onClick={(event) => event.stopPropagation()}>
        <img src={src} alt={alt} />
      </figure>
    </div>
  );
};

export default Lightbox;
